import { useMemo } from 'react';
import { useAuthStore } from '@/store';
import { hasPermission } from '@/lib/permission-match';

/** 当前登录用户的租户权限码是否包含某一项（与后端 TenantScope + 权限 Guard 对齐） */
export function useTenantPermission(code: string): boolean {
  const perms = useAuthStore((s) => s.user?.permissions ?? []);
  return useMemo(() => hasPermission(perms, code), [perms, code]);
}
